import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcCouponFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 4.25c.966 0 1.75.784 1.75 1.75v4a.75.75 0 0 1-.75.75 1.25 1.25 0 1 0 0 2.5.75.75 0 0 1 .75.75v4A1.75 1.75 0 0 1 20 19.75H4A1.75 1.75 0 0 1 2.25 18v-4a.75.75 0 0 1 .75-.75 1.25 1.25 0 1 0 0-2.5.75.75 0 0 1-.75-.75V6c0-.966.784-1.75 1.75-1.75zm-5.666 8.917c-.644 0-1.167.523-1.167 1.167l.006.12c.056.548.493.985 1.042 1.04l.119.006c.604 0 1.1-.459 1.16-1.047l.006-.119c0-.604-.459-1.101-1.047-1.161zm.53-3.96a.75.75 0 0 0-1.061 0l-4.596 4.597a.75.75 0 0 0 1.06 1.06l4.596-4.596a.75.75 0 0 0 0-1.061M9.666 8.5c-.644 0-1.167.523-1.167 1.167l.006.12c.056.548.493.985 1.042 1.04l.119.006c.604 0 1.1-.459 1.16-1.047l.006-.119c0-.604-.459-1.101-1.047-1.161z",
    clipRule: "evenodd"
  }));
}
var IcCouponFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcCouponFill));

export { IcCouponFill as I };
